"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bikeActions = void 0;
var actionFlowOverlays_1 = require("./actionFlowOverlays");
var bikeActionsRaw = [
    // spokes and cranks
    {
        id: 80600,
        groupTitle: 'Spokes',
        caption: 'arSok',
        tagAux: 'arSok',
        tooltip: 'All Rear Spokes OK',
        taskGroup: 'Audit',
        topicDetail: 'Checked OK',
        body: 'Rear',
        value: 100,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Spokes',
            topicDetail: 'Checked OK',
            body: 'Rear',
            tagAux: 'arSok',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80601,
        groupTitle: '',
        caption: 'afSok',
        tagAux: 'afSok',
        tooltip: 'All Front Spokes OK',
        taskGroup: 'Audit',
        topicDetail: 'Checked OK',
        body: 'Front',
        value: 100,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Spokes',
            topicDetail: 'Checked OK',
            body: 'Front',
            tagAux: 'afSok',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80602,
        groupTitle: '',
        caption: 'arSt',
        tagAux: 'arSt',
        tooltip: 'All Rear Spokes Tightened',
        taskGroup: 'Activity',
        topicDetail: 'Tightened',
        body: 'Rear',
        value: 100,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Spokes',
            topicDetail: 'Tightened',
            body: 'Rear',
            tagAux: 'arSt',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80603,
        groupTitle: '',
        caption: 'afSt',
        tagAux: 'afSt',
        tooltip: 'All Front Spokes Tightened',
        taskGroup: 'Activity',
        topicDetail: 'Tightened',
        body: 'Front',
        value: 100,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Spokes',
            topicDetail: 'Tightened',
            body: 'Front',
            tagAux: 'afSt',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80604,
        groupTitle: 'Some',
        caption: 'srSl',
        tagAux: 'srSl',
        tooltip: 'Some Rear Spokes Loose',
        taskGroup: 'Audit',
        topicDetail: 'Loose',
        body: 'Rear',
        value: 80,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Spokes',
            topicDetail: 'Loose',
            body: 'Rear',
            tagAux: 'srSl',
            value: 80,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80605,
        groupTitle: '',
        caption: 'sfSl',
        tagAux: 'sfSl',
        tooltip: 'Some Front Spokes Loose',
        taskGroup: 'Audit',
        topicDetail: 'Loose',
        body: 'Front',
        value: 80,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Spokes',
            topicDetail: 'Loose',
            body: 'Front',
            tagAux: 'sfSl',
            value: 80,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80606,
        groupTitle: 'Many',
        caption: 'mrSl',
        tagAux: 'mrSl',
        tooltip: 'Many Rear Spokes Loose',
        taskGroup: 'Audit',
        topicDetail: 'Loose',
        body: 'Rear',
        value: 20,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Spokes',
            topicDetail: 'Loose',
            body: 'Rear',
            tagAux: 'mrSl',
            value: 20,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80607,
        groupTitle: '',
        caption: 'mfSl',
        tagAux: 'mfSl',
        tooltip: 'Many Front Spokes Loose',
        taskGroup: 'Audit',
        topicDetail: 'Loose',
        body: 'Front',
        value: 20,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Spokes',
            topicDetail: 'Loose',
            body: 'Front',
            tagAux: 'mfSl',
            value: 20,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80608,
        groupTitle: 'Critical',
        caption: 'Scl',
        tagAux: 'Scl',
        tooltip: 'Spokes Critically Loose',
        taskGroup: 'Escalated',
        topicDetail: 'Loose',
        body: '',
        value: 10,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Escalated',
            topicGroup: 'Spokes',
            topicDetail: 'Loose',
            body: '',
            tagAux: 'Scl',
            value: 10,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80609,
        groupTitle: '',
        caption: 'Sbrk',
        tagAux: 'Sbrk',
        tooltip: 'Spokes Broken',
        taskGroup: 'Escalated',
        topicDetail: 'Broken',
        body: '',
        value: 0,
        serviceRealm: 'bikeshare',
        sessionFocus: 'Rectify Spokes',
        viewGroup: 'Focus-1, Spokes, Wheels',
        cssBackground: 'rgba(192,192,192,0.5)',
        topicGroup: 'Spokes',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Escalated',
            topicGroup: 'Spokes',
            topicDetail: 'Broken',
            body: '',
            tagAux: 'Sbrk',
            value: 0,
        },
        cssStyle: { background: 'rgba(192,192,192,0.5)' },
    },
    {
        id: 80630,
        groupTitle: 'Crank Arm',
        caption: 'lCASok',
        tagAux: 'lCASok',
        tooltip: 'Left Crank Arm Screw OK',
        taskGroup: 'Audit',
        topicDetail: 'Checked OK',
        body: 'Left',
        value: 100,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Crank Arm',
            topicDetail: 'Checked OK',
            body: 'Left',
            tagAux: 'lCASok',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 80631,
        groupTitle: '',
        caption: 'rCASok',
        tagAux: 'rCASok',
        tooltip: 'Right Crank Arm Screw OK',
        taskGroup: 'Audit',
        topicDetail: 'Checked OK',
        body: 'Right',
        value: 100,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Crank Arm',
            topicDetail: 'Checked OK',
            body: 'Right',
            tagAux: 'rCASok',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 80632,
        groupTitle: '',
        caption: 'l Scr loose',
        tagAux: 'lCASl',
        tooltip: 'Left Crank Arm Screw Loose',
        taskGroup: 'Audit',
        topicDetail: 'Loose',
        body: 'Left',
        value: 80,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Crank Arm',
            topicDetail: 'Loose',
            body: 'Left',
            tagAux: 'lCASl',
            value: 80,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 80633,
        groupTitle: '',
        caption: 'r Scr loose',
        tagAux: 'rCASl',
        tooltip: 'Right Crank Arm Screw Loose',
        taskGroup: 'Audit',
        topicDetail: 'Loose',
        body: 'Right',
        value: 80,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Crank Arm',
            topicDetail: 'Loose',
            body: 'Right',
            tagAux: 'rCASl',
            value: 80,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 80634,
        groupTitle: '',
        caption: 'l Scr tghtn',
        tagAux: 'lCASt',
        tooltip: 'Left Crank Arm Screw Tightened',
        taskGroup: 'Activity',
        topicDetail: 'Tightened',
        body: 'Left',
        value: 100,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Crank Arm',
            topicDetail: 'Tightened',
            body: 'Left',
            tagAux: 'lCASt',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 80635,
        groupTitle: '',
        caption: 'r Scr tghtn',
        tagAux: 'rCASt',
        tooltip: 'Right Crank Arm Screw Tightened',
        taskGroup: 'Activity',
        topicDetail: 'Tightened',
        body: 'Right',
        value: 100,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Crank Arm',
            topicDetail: 'Tightened',
            body: 'Right',
            tagAux: 'rCASt',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 80636,
        groupTitle: '',
        caption: 'l Scr repl',
        tagAux: 'lCASr',
        tooltip: 'Left Crank Arm Screw Replaced',
        taskGroup: 'Activity',
        topicDetail: 'Replaced',
        body: 'Left',
        value: 100,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Crank Arm',
            topicDetail: 'Replaced',
            body: 'Left',
            tagAux: 'lCASr',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 80637,
        groupTitle: '',
        caption: 'r Scr repl',
        tagAux: 'rCASr',
        tooltip: 'Right Crank Arm Screw Replaced',
        taskGroup: 'Activity',
        topicDetail: 'Replaced',
        body: 'Right',
        value: 100,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Crank Arm',
            topicDetail: 'Replaced',
            body: 'Right',
            tagAux: 'rCASr',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 80638,
        groupTitle: '',
        caption: 'l Arm repl',
        tagAux: 'lCAr',
        tooltip: 'Left Crank Arm Replaced',
        taskGroup: 'Activity',
        topicDetail: 'Replaced',
        body: 'Left',
        value: 100,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Crank Arm',
            topicDetail: 'Replaced',
            body: 'Left',
            tagAux: 'lCAr',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 80639,
        groupTitle: '',
        caption: 'r Arm repl',
        tagAux: 'rCAr',
        tooltip: 'Right Crank Arm Replaced',
        taskGroup: 'Activity',
        topicDetail: 'Replaced',
        body: 'Right',
        value: 100,
        sessionFocus: 'Rectify Cranks',
        viewGroup: 'Focus-1, Cranks',
        cssBackground: 'rgba(192,255,192,0.5)',
        topicGroup: 'Crank Arm',
        viewLevel: 1,
        showBodyInput: false,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Crank Arm',
            topicDetail: 'Replaced',
            body: 'Right',
            tagAux: 'rCAr',
            value: 100,
        },
        cssStyle: { background: 'rgba(192,255,192,0.5)' },
    },
    {
        id: 205,
        viewGroup: 'Travel, Focus-Nav',
        viewLevel: 0,
        groupTitle: null,
        caption: 'Between Bikes',
        materialIcon: 'directions_bike directions_run directions_bike',
        cssStyle: { background: 'rgba(30,240,30,0.3)' },
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Travel',
            topicDetail: 'Between Bikes',
            body: 'Travelling Between Bikes',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 210,
        viewGroup: 'Travel, Logistics',
        viewLevel: 1,
        groupTitle: '{--->}',
        caption: 'Redistributing',
        cssStyle: { background: 'rgba(30,240,200,0.3)' },
        showBodyInput: true,
        showValueInput: true,
        defaultValue: 1,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Transfer to',
            topicDetail: 'Redistributing',
            body: null,
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 211,
        viewGroup: 'Travel, Logistics',
        viewLevel: 1,
        groupTitle: '{<==>}',
        caption: 'Rebalancing',
        cssStyle: { background: 'rgba(30,240,200,0.3)' },
        showBodyInput: true,
        showValueInput: true,
        defaultValue: 1,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Transfer to',
            topicDetail: 'Rebalancing',
            body: null,
            tagAux: null,
            value: 1,
        },
    },
    /*{id: 8801, viewGroup: 'Travel, Logistics, Inventory, Helmet', viewLevel: 1,
        groupTitle: 'Locking', caption: 'bike is unlocked',
        materialIcon: 'directions_bike lock_open',
        cssClass: 'action-locking',
        showBodyInput: true,
        showTagAuxInput: false, tagAuxPlaceholder: null,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Locking',
            topicDetail: 'Unlocked',
            body: null, tagAuxNumericPattern: null,
            tagAux: null, value: null}},*/
    {
        id: 8802,
        viewGroup: 'Travel, Logistics, Inventory, Helmet',
        viewLevel: 0,
        groupTitle: null,
        caption: 'locked to itself',
        materialIcon: 'directions_bike lock_open',
        cssClass: 'action-locking',
        showBodyInput: true,
        showTagAuxInput: false,
        tagAuxPlaceholder: null,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Locking',
            topicDetail: 'Locked to Self',
            body: null,
            tagAuxNumericPattern: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 8803,
        viewGroup: 'Travel, Logistics, Inventory, Helmet',
        viewLevel: 1,
        groupTitle: null,
        caption: 'now locked',
        materialIcon: 'directions_bike lock_open lock',
        cssClass: 'action-locking',
        showBodyInput: true,
        showTagAuxInput: false,
        tagAuxPlaceholder: null,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Locking',
            topicDetail: 'Now Locked',
            body: 'Bike was locked to self',
            tagAuxNumericPattern: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 8810,
        viewGroup: 'Travel, Logistics, Inventory, Focus-Nav',
        viewLevel: 1,
        groupTitle: null,
        caption: 'propose hub or hoops',
        cssClass: 'action-locking',
        showBodyInput: true,
        showTagAuxInput: false,
        tagAuxPlaceholder: null,
        auditRow: {
            taskGroup: 'Proposal',
            topicGroup: 'Locking',
            topicDetail: 'Infrastructure',
            body: null,
            tagAuxNumericPattern: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 8210,
        viewLevel: 0,
        groupTitle: 'Battery Swap',
        caption: 'Out',
        materialIcon: 'swap_horiz',
        cssClass: 'asset-movement-out',
        showBodyInput: false,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'MAxx MCxx',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Battery',
            topicDetail: 'Exchanged (Removed)',
            itemCode: 18062,
            body: 'Battery Removed',
            tagAuxNumericPattern: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 8211,
        viewLevel: 0,
        groupTitle: null,
        caption: 'MA Out',
        cssClass: 'asset-movement-out',
        showBodyInput: false,
        showTagAuxInput: false,
        showTagAuxInputNumeric: true,
        tagAuxPlaceholder: 'A #',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Battery',
            topicDetail: 'Exchanged (Removed)',
            itemCode: 18062,
            body: 'Battery Removed',
            tagAuxNumericPattern: 'MA{numeric2}',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 8212,
        viewLevel: 0,
        groupTitle: null,
        caption: 'MC Out',
        cssClass: 'asset-movement-out',
        showBodyInput: false,
        showTagAuxInput: false,
        showTagAuxInputNumeric: true,
        tagAuxPlaceholder: 'C #',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Battery',
            topicDetail: 'Exchanged (Removed)',
            itemCode: 18062,
            body: 'Battery Removed',
            tagAuxNumericPattern: 'MC{numeric2}',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 8220,
        viewLevel: 0,
        groupTitle: null,
        caption: 'In',
        cssClass: 'asset-movement-in',
        showBodyInput: false,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'MAxx MCxx',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Battery',
            topicDetail: 'Exchanged (Installed)',
            itemCode: 18062,
            body: 'Battery Installed',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 8221,
        viewLevel: 0,
        groupTitle: null,
        caption: 'MA In',
        cssClass: 'asset-movement-in',
        showBodyInput: false,
        showTagAuxInput: false,
        showTagAuxInputNumeric: true,
        tagAuxPlaceholder: 'A #',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Battery',
            topicDetail: 'Exchanged (Installed)',
            itemCode: 18062,
            body: 'Battery Installed',
            tagAuxNumericPattern: 'MA{numeric2}',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 8222,
        viewLevel: 0,
        groupTitle: null,
        caption: 'MC In',
        cssClass: 'asset-movement-in',
        showBodyInput: false,
        showTagAuxInput: false,
        showTagAuxInputNumeric: true,
        tagAuxPlaceholder: 'C #',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Battery',
            topicDetail: 'Exchanged (Installed)',
            itemCode: 18062,
            body: 'Battery Installed',
            tagAuxNumericPattern: 'MC{numeric2}',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 1,
        viewGroup: 'Focus-Helmet',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Helmet',
        caption: 'OK',
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Helmet',
            topicDetail: 'Locked',
            body: 'Helmet was present and Locked OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 2,
        viewGroup: 'Focus-Helmet',
        viewLevel: 0,
        caption: 'is Unlocked',
        materialIcon: 'lock_open',
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Helmet',
            topicDetail: 'Unlocked',
            body: 'Helmet is not locked into U Bar',
            tagAux: null,
            value: 0.8,
        },
    },
    {
        id: 6,
        viewGroup: 'Focus-Helmet',
        viewLevel: 0,
        caption: 'was Unlocked, have now Locked it',
        materialIcon: 'lock_open lock',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Helmet',
            topicDetail: 'Locked',
            body: 'Helmet was not locked into U Bar, have locked now',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 7,
        viewGroup: 'Focus-Helmet',
        viewLevel: 0,
        caption: 'has 2+',
        showValueInput: true,
        defaultValue: 2,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Helmet',
            topicDetail: 'Multiple',
            body: 'Bike has more than 1 helmet',
            tagAux: null,
            value: 2,
        },
    },
    {
        id: 3,
        viewGroup: 'Focus-Helmet',
        viewLevel: 1,
        caption: 'is/was Partially Locked',
        auditRow: {
            topicGroup: 'Helmet',
            taskGroup: 'Activity',
            body: 'Helmet is/was Partially Locked - Now Locked',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 4,
        viewGroup: 'Focus-Helmet',
        viewLevel: 0,
        caption: '{x} Missing',
        auditRow: {
            taskGroup: 'Escalated',
            topicGroup: 'Helmet',
            topicDetail: 'Missing',
            body: 'Helmet Missing',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 50010010,
        viewGroup: 'Focus-Helmet, Logistics, Inventory',
        viewLevel: 1,
        groupTitle: null,
        caption: 'added',
        cssClass: 'asset-movement-in',
        showBodyInput: false,
        showTagAuxInput: false,
        tagAuxPlaceholder: 'code',
        showValueInput: false,
        defaultValue: 1,
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Helmet',
            topicDetail: 'Installed',
            body: null,
            tagAuxNumericPattern: null,
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 50010020,
        viewGroup: 'Focus-Helmet, Logistics, Inventory',
        viewLevel: 1,
        groupTitle: null,
        caption: 'removed',
        cssClass: 'asset-movement-out',
        showBodyInput: false,
        showTagAuxInput: false,
        tagAuxPlaceholder: 'code',
        showValueInput: false,
        defaultValue: -1,
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Helmet',
            topicDetail: 'Removed',
            body: null,
            tagAuxNumericPattern: null,
            tagAux: null,
            value: -1,
        },
    },
    {
        id: 5,
        viewGroup: 'Focus-Helmet',
        viewLevel: 1,
        caption: '{-} Damaged or Dirty',
        auditRow: {
            topicGroup: 'Helmet',
            taskGroup: 'Escalated',
            body: 'Helmet Damaged or Dirty',
            tagAux: null,
            value: 0.5,
        },
    },
    {
        id: 20,
        viewLevel: 0,
        groupTitle: 'Clean',
        caption: 'Cleaned',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        auditRow: { topicGroup: 'Clean', taskGroup: 'Activity', body: 'Cleaned', tagAux: null, value: 1 },
    },
    {
        id: 21,
        viewLevel: 0,
        caption: 'Already Clean',
        materialIcon: 'assignment_turned_in',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        auditRow: { topicGroup: 'Clean', taskGroup: 'Audit', body: 'Already Clean', tagAux: null, value: 1.1 },
    },
    {
        id: 22,
        viewLevel: 0,
        caption: 'Max. Cobwebs/Dust',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Clean',
            body: 'Cleaning Required - Coated in Max. Cobwebs/Dust',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 23,
        viewLevel: 0,
        groupTitle: 'Cobwebs',
        caption: 'Notes',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        showBodyInput: true,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Clean',
            topicDetail: 'Cobwebs',
            body: null,
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 24,
        viewLevel: 0,
        groupTitle: null,
        caption: 'Basket',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        showBodyInput: true,
        defaultBody: 'Basket',
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Clean',
            topicDetail: 'Cobwebs',
            body: 'Basket',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 25,
        viewLevel: 0,
        groupTitle: null,
        caption: 'Levers',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        showBodyInput: true,
        defaultBody: 'Levers',
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Clean',
            topicDetail: 'Cobwebs',
            body: 'Levers',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 26,
        viewLevel: 0,
        groupTitle: null,
        caption: 'Rear',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        showBodyInput: true,
        defaultBody: 'Rear',
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Clean',
            topicDetail: 'Cobwebs',
            body: 'Rear',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 27,
        viewLevel: 0,
        groupTitle: null,
        caption: 'Seat',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        showBodyInput: true,
        defaultBody: 'Seat',
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Clean',
            topicDetail: 'Cobwebs',
            body: 'Seat',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 28,
        viewLevel: 0,
        groupTitle: null,
        caption: 'Wheels',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        showBodyInput: true,
        defaultBody: 'Wheels',
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Clean',
            topicDetail: 'Cobwebs',
            body: 'Wheels',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 29,
        viewLevel: 1,
        caption: '{x} Escalate Cleaning/Washing',
        cssStyle: { background: 'rgba(60,130,255,0.3)' },
        showBodyInput: true,
        defaultBody: 'Wash/Wet Cloth',
        auditRow: {
            taskGroup: 'Escalated',
            topicGroup: 'Clean',
            topicDetail: 'Deep Cleaning Required',
            body: 'Wash/Wet Cloth',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 30,
        viewLevel: 0,
        groupTitle: 'Brakes',
        caption: 'OK',
        auditRow: {
            topicGroup: 'Brakes',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Brakes OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 31,
        viewLevel: 1,
        caption: 'B Adjusted',
        auditRow: {
            topicGroup: 'Brakes',
            taskGroup: 'Activity',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Brakes Adjusted',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 33,
        viewLevel: 1,
        caption: '{x} B Need Adj.',
        auditRow: {
            topicGroup: 'Brakes',
            taskGroup: 'Escalated',
            body: 'Brakes Need Adjustment',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 34,
        viewLevel: 1,
        caption: '{x} Brake Cable Damaged',
        auditRow: {
            topicGroup: 'Brakes',
            taskGroup: 'Escalated',
            body: 'Brake Cable is Damaged',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 40,
        viewLevel: 0,
        groupTitle: 'Gears',
        caption: 'OK',
        auditRow: {
            topicGroup: 'Gears',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Gears OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 41,
        viewLevel: 1,
        caption: 'G Adjusted',
        auditRow: {
            topicGroup: 'Gears',
            taskGroup: 'Activity',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Gears Adjusted',
            tagAux: null,
            value: 0.9,
        },
    },
    {
        id: 43,
        viewLevel: 1,
        caption: '{x} G Need Adj.',
        auditRow: {
            topicGroup: 'Gears',
            taskGroup: 'Escalated',
            body: 'Gears Need Adjustment',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 44,
        viewLevel: 1,
        caption: '{x} Gear Cable Damaged',
        auditRow: {
            topicGroup: 'Gears',
            taskGroup: 'Escalated',
            body: 'Gear Cable is Damaged',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 50,
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Seat',
        caption: 'OK',
        cssStyle: { background: 'rgba(40,40,40,0.2)' },
        auditRow: {
            topicGroup: 'Seat',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Seat OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 51,
        viewGroup: 'Focus-QR',
        viewLevel: 1,
        caption: 'S Adjusted',
        cssStyle: { background: 'rgba(40,40,40,0.2)' },
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Seat',
            topicDetail: 'Adjusted',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Seat Adjusted',
            tagAux: null,
            value: 0.9,
        },
    },
    {
        id: 53,
        viewLevel: 0,
        caption: 'Nuts/Bolts Checked',
        cssStyle: { background: 'rgba(40,40,40,0.2)' },
        showBodyInput: false,
        bodyPlaceholder: 'note',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Seat',
            topicDetail: 'Nuts/Bolts',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Seat Nuts/Bolts Checked and Tightened',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 90500,
        viewGroup: 'Focus-QR',
        viewLevel: 0,
        groupTitle: 'Seat Post',
        caption: 'lubed',
        cssStyle: { background: 'rgba(40,40,40,0.2)' },
        showBodyInput: false,
        bodyPlaceholder: 'note',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Seat',
            topicDetail: 'Lubed',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Seat Post Lubed',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 90510,
        viewGroup: 'Focus-QR',
        viewLevel: 0,
        groupTitle: null,
        caption: 'replaced',
        cssStyle: { background: 'rgba(40,40,40,0.2)' },
        showBodyInput: false,
        bodyPlaceholder: 'note',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Seat',
            topicDetail: 'Exchanged',
            itemCode: null,
            taskRisks: [{ risk: '', control: '' }],
            body: 'Seat Post Replaced',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 54,
        viewGroup: 'Focus-QR',
        viewLevel: 0,
        caption: 'Added QR 2.0 Parts',
        cssStyle: { background: 'rgba(40,150,40,0.4)' },
        showBodyInput: false,
        bodyPlaceholder: 'note',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Seat',
            topicDetail: 'QR 2.0 Parts',
            taskRisks: [{ risk: '', control: '' }],
            body: '',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 55,
        viewGroup: 'Focus-QR',
        viewLevel: 0,
        caption: 'Installed QR 2.0',
        cssStyle: { background: 'rgba(40,150,40,0.4)' },
        showBodyInput: false,
        bodyPlaceholder: 'note',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Seat',
            topicDetail: 'QR 2.0',
            taskRisks: [{ risk: '', control: '' }],
            body: '',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 58,
        viewGroup: 'Focus-QR',
        viewLevel: 1,
        caption: '{x} Quick Release Damaged',
        cssStyle: { background: 'rgba(150,40,40,0.2)' },
        showBodyInput: true,
        bodyPlaceholder: 'note',
        auditRow: {
            taskGroup: 'Escalated',
            topicGroup: 'Seat',
            topicDetail: 'Damaged',
            body: 'Quick Release is Damaged',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 59,
        viewGroup: 'Focus-QR',
        viewLevel: 1,
        caption: "{x} Couldn't Adjust Seat",
        cssStyle: { background: 'rgba(150,40,40,0.2)' },
        showBodyInput: true,
        bodyPlaceholder: 'note',
        auditRow: {
            taskGroup: 'Escalated',
            topicGroup: 'Seat',
            topicDetail: 'Jammed',
            body: "Couldn't Adjust Seat",
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 60,
        viewLevel: 0,
        groupTitle: 'Cables',
        caption: 'Main Cable OK',
        auditRow: {
            topicGroup: 'Cables',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Main Cable OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 63,
        viewLevel: 0,
        caption: 'Moved OK',
        auditRow: {
            topicGroup: 'Cables',
            taskGroup: 'Activity',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Main Cable Moved OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 64,
        viewLevel: 1,
        caption: 'Damaged',
        auditRow: {
            topicGroup: 'Cables',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Main Cable Damaged',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 70,
        viewLevel: 0,
        groupTitle: 'Levers',
        caption: '90mm - OK',
        auditRow: {
            topicGroup: 'Levers',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Levers OK, allowing 90mm for grip',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 75,
        viewLevel: 1,
        caption: 'Need Adj',
        auditRow: {
            topicGroup: 'Levers',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Levers Need Adjustment',
            tagAux: null,
            value: 0.5,
        },
    },
    {
        id: 80,
        viewLevel: 1,
        groupTitle: 'Rear Lens',
        caption: 'Issue with Inserts',
        auditRow: {
            topicGroup: 'Rear Lens Brass Inserts',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Check/Replace Rear Lens Inserts',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 82,
        viewLevel: 1,
        caption: 'Issue with Lens',
        auditRow: {
            topicGroup: 'Rear Lens',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Check/Replace Rear Lens',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 800,
        viewLevel: 0,
        groupTitle: 'Mudguards',
        caption: 'OK',
        auditRow: {
            topicGroup: 'Mudguard',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Mudguards OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 801,
        viewLevel: 0,
        caption: 'Relatively OK',
        auditRow: {
            topicGroup: 'Mudguard',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Mudguards Relatively OK',
            tagAux: null,
            value: 0.75,
        },
    },
    {
        id: 808,
        viewLevel: 1,
        caption: 'Mudguard Issue',
        auditRow: {
            topicGroup: 'Mudguard',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Issue with Mudguard',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 810,
        viewLevel: 0,
        groupTitle: 'Basket',
        caption: 'OK',
        auditRow: {
            topicGroup: 'Basket',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Basket OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 818,
        viewLevel: 1,
        caption: 'Basket Issue',
        auditRow: {
            topicGroup: 'Basket',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Issue with Basket',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 820,
        viewLevel: 0,
        groupTitle: 'Bell',
        caption: 'OK',
        auditRow: {
            topicGroup: 'Bell',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Bell OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 828,
        viewLevel: 1,
        caption: 'Issue with Bell',
        auditRow: {
            topicGroup: 'Bell',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Issue with Bell',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 830,
        viewLevel: 0,
        groupTitle: 'Drive Shaft/Chain',
        caption: 'OK',
        auditRow: {
            topicGroup: 'Drive',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Drive Shaft or Chain OK',
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 837,
        viewLevel: 1,
        caption: 'Shaft Needs Lube',
        auditRow: {
            topicGroup: 'Drive',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Shaft Needs Lube',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 838,
        viewLevel: 1,
        caption: 'Needs Chain Lube',
        auditRow: {
            topicGroup: 'Drive',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Needs Chain Lube',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 900,
        viewLevel: 0,
        groupTitle: 'Test Ride',
        caption: 'Riding Now...',
        cssStyle: { background: '#b0d9be' },
        auditRow: {
            topicGroup: 'Test Ride',
            taskGroup: 'Activity',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Test Riding',
            tagAux: null,
            value: 50,
        },
    },
    {
        id: 905,
        viewLevel: 0,
        caption: '{x} Failed',
        auditRow: {
            topicGroup: 'Test Ride',
            taskGroup: 'Escalated',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Test Ride Failed',
            tagAux: null,
            value: 0,
        },
    },
    {
        id: 910,
        viewLevel: 0,
        caption: 'Test OK',
        cssStyle: { background: '#b0d9be' },
        auditRow: {
            topicGroup: 'Test Ride',
            taskGroup: 'Activity',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Test Rode OK',
            tagAux: null,
            value: 100,
        },
    },
    {
        id: 911,
        viewLevel: 0,
        caption: 'Smooth Ride',
        cssStyle: { background: '#b0d9be' },
        auditRow: {
            topicGroup: 'Test Ride',
            taskGroup: 'Audit',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Smooth Ride',
            tagAux: null,
            value: 100,
        },
    },
    {
        id: 912,
        viewLevel: 0,
        caption: 'Soft Tyres',
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Test Ride',
            topicDetail: 'Soft Tyres',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Soft Tyres',
            tagAux: null,
            value: 80,
        },
    },
    {
        id: 913,
        viewLevel: 0,
        caption: 'Skipping Gears',
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Test Ride',
            taskRisks: [{ risk: '', control: '' }],
            body: 'Skipping Gears',
            tagAux: null,
            value: 80,
        },
    },
    {
        id: 920,
        viewLevel: 0,
        caption: 'Note',
        cssStyle: { background: '#b0d9be' },
        showBodyInput: true,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Test Ride',
            topicDetail: 'Note',
            taskRisks: [{ risk: '', control: '' }],
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 80500,
        viewGroup: 'Focus-1',
        viewLevel: 0,
        groupTitle: 'Stickers',
        caption: 'added v2',
        cssStyle: { background: 'rgba(40,240,100,0.2)' },
        showBodyInput: true,
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Stickers',
            topicDetail: 'Installed',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 300,
        viewLevel: 0,
        groupTitle: 'Tyres',
        caption: 'psi',
        cssStyle: { background: 'rgba(40,100,200,0.2)' },
        showValueInput: true,
        auditRow: {
            topicGroup: 'Tyres',
            topicDetail: 'Tyre Pressure',
            taskGroup: 'Audit',
            body: 'psi',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 301,
        viewLevel: 1,
        groupTitle: 'Front',
        caption: 'psi',
        cssStyle: { background: 'rgba(40,100,200,0.2)' },
        showValueInput: true,
        auditRow: {
            topicGroup: 'Tyres',
            topicDetail: 'Tyre Pressure (Front)',
            taskGroup: 'Audit',
            body: 'psi',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 302,
        viewLevel: 1,
        groupTitle: 'Rear',
        caption: 'psi',
        cssStyle: { background: 'rgba(40,100,200,0.2)' },
        showValueInput: true,
        auditRow: {
            topicGroup: 'Tyres',
            topicDetail: 'Tyre Pressure (Rear)',
            taskGroup: 'Audit',
            body: 'psi',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 312,
        viewLevel: 0,
        caption: 'Inflated to _ psi',
        cssStyle: { background: 'rgba(40,100,200,0.2)' },
        showValueInput: true,
        defaultValue: 80,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Tyres',
            topicDetail: 'Tyre Pressure',
            body: 'Inflated Tyres to',
            tagAux: null,
            value: 80,
        },
    },
    {
        id: 313,
        viewLevel: 1,
        caption: '{x} Escalate Tyre Inflation',
        cssStyle: { background: 'rgba(40,100,200,0.2)' },
        auditRow: {
            topicGroup: 'Tyres',
            taskGroup: 'Escalated',
            taskRisks: [
                {
                    risk: 'Trip hazards',
                    control: 'Keep clear of walways, ensure bags and tools are neatly tucked' +
                        ' away from walkways and ...' +
                        ' to reduce the risk of tripping people' +
                        ' who need to access bike hoops',
                },
                { risk: 'back strain' },
            ],
            body: 'Inflate Tyres',
            tagAux: null,
            value: 0,
        },
    },
    /*{id: 399, viewLevel: 0, caption: 'Next',
        step
        cssStyle: {background: 'rgba(40,100,200,0.2)'},
        auditRow: {}},*/
    {
        id: 1000,
        viewLevel: 0,
        groupTitle: 'ALL',
        caption: 'All Checks OK',
        cssStyle: { background: 'rgba(40,200,40,0.2)' },
        auditRow: { topicGroup: 'Check', taskGroup: 'Activity', body: 'All Checks OK', tagAux: null, value: 100 },
    },
    /* TEMPLATE
    {id: , viewLevel: 0, caption: '',
        auditRow: {topicGroup: '', taskGroup: '',
            taskRisks: [
                {risk: '', control: ''}
            ],
            body: '', tagAux: '', value: }},
*/
];
/** Configured: Audit/I, Logistics/L, Activity/T — see actionFlowOverlays.ts */
exports.bikeActions = (0, actionFlowOverlays_1.configureBikeActions)(bikeActionsRaw);
